import { render, staticRenderFns } from "./ProgressComp.vue?vue&type=template&id=2b4e01d4&scoped=true&"
import script from "./ProgressComp.vue?vue&type=script&lang=ts&"
export * from "./ProgressComp.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressComp.vue?vue&type=style&index=0&id=2b4e01d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4e01d4",
  null
  
)

export default component.exports